<div class="add-delegate-container">
    <div *ngIf="!isModal" class="row">
        <span class="col-12 title">{{'requests.wizard.addDelegateForm.title' | translate}}</span>
    </div>

    <div *ngIf="isModal" class="d-flex justify-content-start align-items-center back-to-delegates gap-2">
        <button class="btn outline-btn btn-back-custom" (click)="backToDelegatesList()">
            <i class="app-icon icon icon-chevron-left icon-sm"></i>
        </button>
        <span class="back-to-delegates-text">{{ "requests.wizard.addDelegateForm.backToDelegatesList" | translate }}</span>
    </div>

    <div *ngIf="isModal" class="row row-modal document-upload-section gap-1">
        <div class="label-input fs-6 px-0">{{ "requests.wizard.addDelegateForm.uploadId" | translate }}</div>
        <div class="import-file-container">
            <input
                type="file"
                class="input-file cursor-pointer"
                accept=".jpg,.jpeg,.png,.gif"
                (change)="onFileSelected($event)"
            />
            <div class="import-file-label d-flex flex-column align-items-center gap-2">
                <div class="upload-icon-box d-flex align-items-center justify-content-center">
                    <i class="app-icon icon icon-upload-cloud-02 icon-lg"></i>
                </div>
                <div class="upload-info text-center">
                    <div class="upload-hint mb-1" [innerHTML]="'common.uploadPresentationDocument' | translate">
                    </div>
                    <div class="upload-note fs-12px">
                        {{ 'JPG, JPEG, PNG '+ ('common.or' | translate) +' GIF' }}
                    </div>
                </div>
            </div>
        </div>
        <div class="label-input fs-12px px-0">{{ "requests.wizard.addDelegateForm.uploadIdDescription" | translate }}</div>
        <div *ngIf="selectedFile" class="label-input fs-12px px-0 d-flex align-items-center">
            <span>{{ selectedFile.name }}</span>
            <button type="button" class="btn delete-btn" (click)="removeFile($event)">
                <i class="app-icon icon icon-delete icon-md"></i>
            </button>
        </div>
    </div>

    <form #addDelegate="ngForm" class="add-delegate-form-container">
        <div class="row justify-content-center" [ngClass]="{ 'row-modal': isModal }">
            <div class="input-col"
                [ngClass]="{'col-6': isModal, 'col-md-6 col-lg-5 col-xxl-4 col-xxxl-3': !isModal }"
            >
                <label class="label-input required">
                    {{'requests.wizard.addDelegateForm.firstName' | translate}}
                </label>
                <input kendoTextBox
                    class="text-input"
                    [ngClass]="{ 'border-modal': isModal }"
                    name="firstName"
                    #firstName="ngModel"
                    type="text"
                    placeholder="{{ 'requests.wizard.addDelegateForm.placeholder.firstName' | translate }}"
                    [(ngModel)]="newDelegate.firstName" 
                    minlength="3"
                    required
                    >
                <div class="error-info" *ngIf="firstName.invalid  && (firstName.dirty || addDelegate.submitted)">
                    <div  *ngIf="firstName.errors?.['minlength']">
                        {{'common.validation.required' | translate}}
                    </div>
                    <div  *ngIf="firstName.errors?.['pattern']">
                        {{'common.validation.firstNameInvalid' | translate}}
                    </div>
                </div>
            </div>
            <div class="input-col"
                [ngClass]="{'col-6': isModal, 'col-md-6 col-lg-5 col-xxl-4 col-xxxl-3': !isModal }"
            >
                <label class="label-input required">
                    {{'requests.wizard.addDelegateForm.lastName' | translate}}
                </label>
                <input kendoTextBox
                    class="text-input"
                    [ngClass]="{ 'border-modal': isModal }"
                    name="lastName"
                    #lastName="ngModel"
                    type="text"
                    placeholder="{{ 'requests.wizard.addDelegateForm.placeholder.lastName' | translate }}"
                    [(ngModel)]="newDelegate.lastName" 
                    minlength="3"
                    required
                >
                <div class="error-info" *ngIf="lastName.invalid  && (lastName.dirty || addDelegate.submitted)">
                    <div  *ngIf="lastName.errors?.['required']" >
                        {{'common.validation.required' | translate}}
                    </div>
                    <div  *ngIf="lastName.errors?.['minlength']">
                        {{'common.validation.lastNameInvalid' | translate}}
                    </div>
                </div>
            </div>
        </div>

        <div class="row justify-content-center" [ngClass]="{ 'row-modal': isModal }">
            <div class="input-col"
                [ngClass]="{'col-6': isModal, 'col-md-6 col-lg-5 col-xxl-4 col-xxxl-3': !isModal }"
            >
                <label class="label-input required">
                    {{'requests.wizard.addDelegateForm.personalIdNumber' | translate}}
                </label>
                <input kendoTextBox
                    id="PIN"
                    class="text-input"
                    [ngClass]="{ 'border-modal': isModal }"
                    name="PIN"
                    #PIN="ngModel"
                    ng-model="PIN"
                    type="text"
                    placeholder="{{ 'requests.wizard.addDelegateForm.placeholder.personalIdNumber' | translate }}"
                    [(ngModel)]="newDelegate.personalIdNumber" 
                    required
                    [pattern]="pinValidator?.regex"
                />

                <div class="error-info" *ngIf="PIN.invalid  && (PIN.dirty || addDelegate.submitted)">
                    <div  *ngIf="PIN.errors?.['required']" >
                        {{'common.validation.required' | translate}}
                    </div>
                    <div  *ngIf="PIN.errors?.['pattern']">
                        {{'requests.wizard.addDelegateForm.invalidPIN' | translate}}
                    </div>
                </div>
            </div>
            <div class="input-col"
                [ngClass]="{'col-6': isModal, 'col-md-6 col-lg-5 col-xxl-4 col-xxxl-3': !isModal }"
            >
                <label class="label-input required">
                    {{'requests.wizard.addDelegateForm.idSeriesAndNumber' | translate}}
                </label>
                <input kendoTextBox
                    class="text-input"
                    [ngClass]="{ 'border-modal': isModal }"
                    name="idSeriesAndNumber"
                    #idSeriesAndNumber="ngModel"
                    type="text"
                    placeholder="{{ 'requests.wizard.addDelegateForm.placeholder.idSeriesAndNumber' | translate }}"
                    [(ngModel)]="newDelegate.idSerialNumber" 
                    required
                    >
                <div class="error-info" *ngIf="idSeriesAndNumber.invalid  && (idSeriesAndNumber.dirty || addDelegate.submitted)">
                    <div  *ngIf="idSeriesAndNumber.errors?.['required']" >
                        {{'common.validation.required' | translate}}
                    </div>
                </div>
            </div>
        </div>

        <div class="row justify-content-center" [ngClass]="{ 'row-modal': isModal }">
            <div class="input-col"
                [ngClass]="{'col-6': isModal, 'col-md-6 col-lg-5 col-xxl-4 col-xxxl-3': !isModal }"
            >
                <label class="label-input required">
                    {{'requests.wizard.addDelegateForm.issuedBy' | translate}}
                </label>
                <input kendoTextBox
                    class="text-input"
                    [ngClass]="{ 'border-modal': isModal }"
                    name="issuedBy"
                    #issuedBy="ngModel"
                    type="text"
                    placeholder="{{ 'requests.wizard.addDelegateForm.placeholder.issuedBy' | translate }}"
                    [(ngModel)]="newDelegate.issuedBy" 
                    required
                    >
                <div class="error-info" *ngIf="issuedBy.invalid  && (issuedBy.dirty || addDelegate.submitted)">
                    <div  *ngIf="issuedBy.errors?.['required']" >
                        {{'common.validation.required' | translate}}
                    </div>
                </div>
            </div>

            <div class="input-col"
                [ngClass]="{'col-6': isModal, 'col-md-6 col-lg-5 col-xxl-4 col-xxxl-3': !isModal }"
            >
                <label class="label-input required">
                    {{'requests.wizard.addDelegateForm.expiryDate' | translate}}
                </label>
                <kendo-datepicker HJSuppress
                    class="custom-kendo-control-xl"
                    [ngClass]="{ 'border-modal': isModal }"
                    [fillMode]="fillModeOutline"
                    [rounded]="roundedLarge"
                    #expiryDate="ngModel"
                    #expiryDateControl
                    name="expiryDateControl"
                    [disabledDates]="disabledDates" 
                    [(ngModel)]="newDelegate.expiryDate"
                    (click)="!expiryDateControl.isOpen ? expiryDateControl.toggle() : null"
                    required
                    [popupSettings]="{popupClass : 'data-hj-suppress'}"
                >
                    <kendo-datepicker-messages 
                        today="{{ 'calendar.today' | translate }}"
                        toggle="{{ 'calendar.toggle' | translate }}">
                    </kendo-datepicker-messages>
                </kendo-datepicker>
                
                <div class="error-info" *ngIf="expiryDate.invalid  && (expiryDate.dirty || addDelegate.submitted)">
                    <div  *ngIf="expiryDate.errors?.['required']" >
                        {{'common.validation.required' | translate}}
                    </div>
                </div>
                <div class="error-info" *ngIf="expiryDate.invalid">
                    <div  *ngIf="expiryDate.errors?.['disabledDate']" >
                        {{'common.validation.expiryDateInvalid' | translate}}
                    </div>
                </div>
            </div>
        </div>

        <div class="row justify-content-center" [ngClass]="{ 'row-modal': isModal }">
            <div class="input-col"
                [ngClass]="{'col-6': isModal, 'col-md-6 col-lg-5 col-xxl-4 col-xxxl-3': !isModal }"
            >
                <label class="label-input required">
                    {{'requests.wizard.addDelegateForm.email' | translate}}
                </label>
                <input kendoTextBox
                    class="text-input"
                    [ngClass]="{ 'border-modal': isModal }"
                    name="email"
                    #email="ngModel"
                    type="text"
                    placeholder="{{ 'requests.wizard.addDelegateForm.placeholder.email' | translate }}"
                    [(ngModel)]="newDelegate.email" 
                    [pattern]="emailValidator"
                    required
                    >       
                <div class="error-info" *ngIf="email.invalid  && (email.dirty || addDelegate.submitted)">
                    <div  *ngIf="email.errors?.['required']" >
                        {{'common.validation.required' | translate}}
                    </div>
                    <div  *ngIf="email.errors?.['pattern']">
                        {{'common.validation.emailInvalid' | translate}}
                    </div>
                </div>
            </div>
            <div class="input-col"
                [ngClass]="{'col-6': isModal, 'col-md-6 col-lg-5 col-xxl-4 col-xxxl-3': !isModal }"
            >        
                <label class="label-input required">
                    {{'requests.wizard.addDelegateForm.phone' | translate}}
                </label>
                <input kendoTextBox
                    id="phone"
                    class="text-input"
                    [ngClass]="{ 'border-modal': isModal }"
                    name="phone"
                    #phone="ngModel"
                    ng-model="phone"
                    type="text"
                    placeholder="{{ 'requests.wizard.addDelegateForm.placeholder.phone' | translate }}"
                    [(ngModel)]="newDelegate.phone" 
                    required
                    [pattern]="phoneValidator?.regex"                    
                    >
                <div class="error-info" *ngIf="phone.invalid  && (phone.dirty || addDelegate.submitted)">
                    <div  *ngIf="phone.errors?.['required']" >
                        {{'common.validation.required' | translate}}
                    </div>
                    <div  *ngIf="phone.errors?.['pattern']">
                        {{'requests.wizard.addDelegateForm.invalidPhone' | translate}}
                    </div>
                </div>
            </div>
        </div>
        <div class="row" [ngClass]="{ 'justify-content-start row-modal': isModal, 'justify-content-center': !isModal }">
            <div class="col-12 col-lg-10 col-xxl-8 col-xxxl-6 required-fields-label"
                [innerHTML] ="'common.requiredFields' | translate">
            </div>
        </div>

        <div *ngIf="!isModal" class="row">
            <div class="col-12 action d-flex justify-content-center">
                <button class="{{ loading ? 'btn primary-btn is-disabled' : 'btn primary-btn'}}" (click)="handlerSaveDelegate()" [disabled]="loading">{{submitButtonText | translate}}         
                </button>
            </div>
        </div>
    </form>
</div>